import { FilterFieldValueSegment } from 'common/filter/interfaces'
import {
  reasonTypeLabels,
  reasonTypeSequence,
} from 'common/oneTimeNotify/constants/notifyReasonConstants'

import {
  FieldValuePickerDefaultOption,
  FieldValuePickerDefaultOptionWithEntityType,
  FieldValuePickerGroupedOption,
  FieldValuePickerOption,
} from './interfaces'

export const prepareGroupedOption = (
  options: FieldValuePickerDefaultOptionWithEntityType[],
): FieldValuePickerGroupedOption[] => {
  if (!options.length) return []
  // prepare object
  const preparedOptions: Record<string, FieldValuePickerGroupedOption> = {}
  options.forEach((option) => {
    preparedOptions[option.entity_type]
      ? preparedOptions[option.entity_type].options.push(getPrepareOption(option))
      : (preparedOptions[option.entity_type] = {
          label: reasonTypeLabels[option.entity_type],
          options: [getPrepareOption(option)],
        })
  })
  // sort by reasonType
  const result: FieldValuePickerGroupedOption[] = []
  reasonTypeSequence.forEach((el) => preparedOptions[el] && result.push(preparedOptions[el]))

  return result
}

const getPrepareOption = (option: FieldValuePickerDefaultOption): FieldValuePickerOption => {
  return {
    label: option.label,
    type: option.type,
    value: option.value,
    segment_type: option.segment_id,
    count: option.count,
  }
}

export const FOLLOW_UP_FIELD = 'follow-up eligible'
export const OUTSIDE_24_WINDOW_FIELD = 'outside 24+1 window'

export const isNeedGroupOption = (
  options: FieldValuePickerDefaultOption[],
): options is FieldValuePickerDefaultOptionWithEntityType[] => {
  return options.every((option) => Boolean(option.entity_type))
}

export const generateFieldValuePickerConfig = (fieldValues: FilterFieldValueSegment[]) => {
  const isActive = (fieldValue: FilterFieldValueSegment) => fieldValue.active
  const isNotExcluded = (fieldValue: FilterFieldValueSegment) =>
    !new Set<string | number>([FOLLOW_UP_FIELD, OUTSIDE_24_WINDOW_FIELD]).has(fieldValue.value)

  const options = fieldValues
    .filter(isActive)
    .filter(isNotExcluded)
    .map((option) => ({
      ...option,
      value: (option.value || option.segment_id?.split('_')[1]) ?? null,
      count: option.count || 0,
    }))

  const maxOptionsWithoutSearch = 8
  const showSearch = options.length > maxOptionsWithoutSearch

  return {
    showSearch,
    options: isNeedGroupOption(options) ? prepareGroupedOption(options) : options,
  }
}
